<template>
  <div class="shopping-cart">
    <div class="goods-cart" v-if="type === '2'" @click="showDetailUrlDialog">
      <div class="goods-pic">
        <img :src="goodsInfo.cover" alt="" srcset="" />
      </div>
      <p class="title">{{ goodsInfo.name }}</p>
      <div class="pirce">
        <span>￥{{ goodsInfo.price }}</span>
        <span class="go">抢</span>
      </div>
      <i class="el-icon-close close" @click.stop="hideDiaog"></i>
    </div>

    <div class="shopping-dialog" v-if="type === '3'">
      <div class="shopping-dialog-content">
        <div class="wrapper">
          <div class="goods-content">
            <img class="goods-pic" :src="goodsInfo.cover" width="96" />
            <div class="goods-info">
              <p class="title">{{ goodsInfo.name }}</p>
              <p class="price">￥{{ goodsInfo.price }}</p>
            </div>
          </div>
        </div>
        <div class="shopping-btn" @click="showDetailUrlDialog">立即抢购</div>
      </div>
      <div style="text-align: center; margin-top: 30px">
        <img
          src="../../assets/imgs/close_white.png"
          style="cursor: pointer"
          @click="hideDiaog"
          alt=""
          srcset=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import tool from "@/kits/Tools.js";
import qs from "qs";
export default {
  name: "",
  props: {
    type: {
      type: String,
      default: "",
    },
    goodsInfo: {
      type: Object,
      default: () => {},
    },
    fans_id: {
      type: String | Number,
      default: "",
    },
    channel_id: {
      type: String | Number,
      default: "",
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    hideDiaog() {
      this.$emit("hide");
    },
    async collectRecordFn(id) {
      // 采集购买记录
      const params = {
        id,
        type: 1,
        fans_id: this.fans_id,
        channel_id: this.channel_id,
        ds_id: tool.getQueryString("ds_id"),
      };
      await this.axios.post(
        tool.baseUrl2() + "/api/goods/info",
        qs.stringify(params)
      );
    },
    async showDetailUrlDialog() {
      this.hideDiaog();
      const { id, jump, payurl } = this.goodsInfo;
      if (jump === 1) {
        await this.collectRecordFn(id);
        window.open(payurl);
      } else {
        this.$emit("showGoodsQrCode", id);
      }
    },
  },
};
</script>
<style scoped>
.goods-cart {
  position: absolute;
  right: 15px;
  bottom: 145px;
  z-index: 999;
  cursor: pointer;
}
.goods-cart img {
  width: 123px;
  height: 80px;
}
.goods-cart .close {
  position: absolute;
  top: 11px;
  right: 0px;
  z-index: 9999;
  margin-top: -8px;
  color: #ffffff;
}
.goods-cart .title {
  width: 115px;
  color: #202020;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #ffffff;
  padding: 6px 4px;
  font-size: 12px;
  margin-top: -2px;
}
.goods-cart .pirce {
  display: flex;
  justify-content: space-between;
  padding: 2px;
  color: #ffffff;
  background: url("../../assets/imgs/shopping_price_bg.png") no-repeat;
  background-size: 100% 100%;
}
.goods-cart .pirce .go {
  margin-right: 8px;
}

.shopping-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: auto;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999999;
}
.shopping-dialog .shopping-dialog-content {
  width: 360px;
  height: 360px;
  background: url("../../assets/imgs/gouwuchebeij.png") no-repeat;
  background-size: 100% 100%;
}
.shopping-dialog .shopping-dialog-content .wrapper {
  padding-top: 130px;
}
.shopping-dialog-content .goods-content {
  display: flex;
  width: 330px;
  height: 170px;
  margin: auto;
  padding: 26px 40px 48px;
  box-sizing: border-box;
  background: url("../../assets/imgs/goods_bg.png") no-repeat;
  background-size: 100% 100%;
}
.shopping-dialog-content .goods-content .goods-pic {
  width: 96px;
  height: 96px;
  flex-shrink: 0;
  margin-right: 10px;
}
.shopping-dialog-content .goods-content .goods-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.shopping-dialog-content .goods-content .goods-info .title {
  font-size: 14px;
  color: #202020;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.shopping-dialog-content .goods-content .goods-info .price {
  color: #ee4359;
  /* text-align: right; */
}
.shopping-dialog-content .shopping-btn {
  width: 218px;
  height: 40px;
  background: linear-gradient(180deg, #ff9c3e, #ffc957 100%);
  border-radius: 20px;
  box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0.08) inset;
  font-size: 17px;
  font-family: Noto Sans SC, Noto Sans SC-700;
  font-weight: 700;
  color: #c65500;
  margin: auto;
  /* background: url('../../assets/imgs/shopping-btn-bg.png') no-repeat;
  background-size: 100% 100%; */
  text-align: center;
  line-height: 40px;
  margin-top: -10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ShoppingCart/index.vue